/**
 * Prod often 404s on /api/uploads/{comune}/… even when files exist locally.
 * Ship certified copies under /images/ and rewrite at resolve time.
 * Never invent /assets/nodi/ or fake *-proprietaria.webp.
 */

const PREFIX_REWRITES = [
  { from: "/api/uploads/assergi/", to: "/images/assergi/" },
];

/** Montorio: wiki filenames → curated /images paths (hero = San Rocco, not Tempio dig). */
const EXACT_REWRITES = {
  "/api/uploads/montorio-al-vomano/wiki-san-rocco.jpg":
    "/images/montorio-al-vomano/san-rocco.jpg",
  "/api/uploads/montorio-al-vomano/wiki-collevecchio-strada.jpg":
    "/images/montorio-al-vomano/collevecchio.jpg",
  "/api/uploads/montorio-al-vomano/wiki-tempio-ercole.jpg":
    "/images/montorio-al-vomano/tempio-ercole.jpg",
  "/api/uploads/admin/fcc647f25da14298a77d488bd4c7a251.jpg":
    "/hero/montorio-al-vomano.jpg",
  "/api/uploads/campo-imperatore/campo-imperatore-funivia-gran-sasso.png":
    "/images/assergi/wiki-funivia.jpg",
  "/api/uploads/assergi/san-pietro-jenca-statua-e-chiesa.jpg":
    "/hero/assergi.jpg",
  "/api/uploads/santo-stefano-di-sessanio/comune-santo-stefano-di-sessanio-01-p-20180814-155008.jpg":
    "/hero/santo-stefano-di-sessanio.jpg",
};

/** Copertine monumenti Assergi (bellezze) quando Mongo punta a upload 404. */
export const ASSERGI_MONUMENT_COVER_BY_SLUG = {
  "assergi__santuario-san-giovanni-paolo-ii": "/hero/assergi-jenca-statua.jpg",
  "assergi__chiesa-santa-maria-assunta": "/hero/assergi-chiesa-01.jpg",
  "assergi__funivia-gran-sasso": "/hero/assergi-funivia.jpg",
  "borgo-di-assergi": "/hero/assergi-chiesa-02.jpg",
  "fonte-cerreto": "/hero/assergi-fonte-cerreto.jpg",
  "assergi__fonte-cerreto": "/hero/assergi-fonte-cerreto.jpg",
};

/**
 * Rewrite known-dead /api/uploads paths to shipped /hero or /images assets.
 * Returns original url if no rewrite applies.
 */
export function rewriteUploadToStatic(url) {
  if (!url || typeof url !== "string") return url;
  const raw = url.trim();
  if (!raw) return raw;

  let path = raw;
  try {
    if (/^https?:\/\//i.test(raw)) {
      const u = new URL(raw);
      path = u.pathname || raw;
    }
  } catch {
    path = raw;
  }

  if (EXACT_REWRITES[path]) return EXACT_REWRITES[path];

  for (const { from, to } of PREFIX_REWRITES) {
    if (path.startsWith(from)) {
      return `${to}${path.slice(from.length)}`;
    }
  }

  return raw;
}

export function monumentStaticCover(monument) {
  if (!monument) return null;
  const slug = String(monument.slug || "").trim().toLowerCase();
  if (slug && ASSERGI_MONUMENT_COVER_BY_SLUG[slug]) {
    return ASSERGI_MONUMENT_COVER_BY_SLUG[slug];
  }
  return null;
}
